



let findParentBg = function(obj) {
    let parent = obj.parent();

    if(!parent)
        return false;

    if(parent.css('background-image') && parent.css('background-image') != 'none')
        return parent;

    return findParentBg(parent)
}


let blurAll = function() {
    $('.blur').each(function() {
        if($(this).hasClass("no-mobile") && $(window).width() <= "768"){
            return true;
        }
        let parent = findParentBg($(this))
        if(parent) {

            let mode = $(this).data('mode') ? $(this).data('mode') : 'default';

            let xPos = $(this).offset().left;
            let yPos = $(this).offset().top;

            let relativeParent = parent.offset()
            if(relativeParent) {
                xPos -= relativeParent.left
                yPos -= relativeParent.top
            }

            let targetWidth = $(this).width();
            let targetHeight = $(this).height();

            
            

            if(mode == 'copy') {
                if(!$(this).parent().hasClass('blurparent')) {
                    $(this).parent().prepend('<div class="blurparent"><div class="blurbody" style="position: absolute;"></div></div>')
                    $(this).appendTo($(this).parent().find('.blurparent'));
                    $(this).children().appendTo($(this).parent().find('.blurbody'));
                }
            }
            else
            {
                if($(this).find('.blurbody').length == 0) {
                    $(this).prepend('<div class="blurbody"></div>')
                    $(this).children().appendTo($(this).find('.blurbody'));
                }
            }

            if($(this).find('.blurbg').length == 0) {
                $(this).find('.blurbg').remove();
                $(this).prepend('<div class="blurbg"></div>')
            }


            //$(this).css('position', 'relative');
            //$(this).css('overflow', 'hidden');



            let $childrens = $(this).parent().find('.blurbody').children();
            let $firstChild = $childrens.length > 0 ? $($childrens[0]) : null;
            if($firstChild && $firstChild.css('display') == 'flex') {
                $(this).css('width', '100%');
                $(this).css('height', '100%');

            } else {

                if($(this).closest('.sfwbg-text').length > 0) {
                    let negativeMarginBottom = Number($(this).closest('.sfwbg-text').css('margin-bottom').replace('px', ''))
                    if(negativeMarginBottom < 0) {
                        targetHeight += negativeMarginBottom
                    }
                }

                $(this).css('width', targetWidth);
                $(this).css('height', targetHeight);

            }

            $(this).find('.blurbg').width(parent.width());
            $(this).find('.blurbg').height(parent.height());

            //$(this).find('.blurbg').css('position', 'absolute');
            //$(this).find('.blurbg').css('z-index', -1);
            $(this).find('.blurbg').css('background-image', parent.css('background-image'));
            $(this).find('.blurbg').css('background-position', parent.css('background-position'));
            $(this).find('.blurbg').css('background-size', parent.css('background-size'));
            $(this).find('.blurbg').css('background-repeat', parent.css('background-repeat'));
            //$(this).find('.blurbg').css('filter', 'blur(30px)');
            $(this).find('.blurbg').css('left', (xPos * -1) + 'px');
            $(this).find('.blurbg').css('top', (yPos * -1) + 'px');
            //$(this).find('.blurbody').css('background-color', 'rgba(255,255,255,0.2)');

        }
    });
}

blurAll();

$(window).on('resize', function() {
    blurAll();
})


// WEBPACK FOOTER //
// ./web/themes/custom/atolbtob/js/components/blur.js